import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { userJoinCompanys } from '@/utils/api/common';

const initialState = {
  list: [],
};

export const asyncCompanyInit = createAsyncThunk("notice/asyncCompanyInit", async (_, state) => {
  const { cart: { list = [] }, } = state.getState();
  const { data: { data = {}, code }, } = await userJoinCompanys();
  if (+code === 0) {
    const { list = [] } = data;
    return list;
  } else {
    return list;
  }
});


export const slice = createSlice({
  name: "company",
  initialState,
  reducers: {
    // updateSelectProducts: (state, action) => {
    //   state.selectProducts = action.payload;
    // },
    // updateSubmitList: (state, action) => {
    //   state.selectCartList = action.payload;
    // },
  },
  extraReducers: (builder) => {
    builder
      .addCase(asyncCompanyInit.fulfilled, (state, actions) => {
        state.list = actions.payload;
      });
  },
});

const { reducer } = slice;
// const { reducer, actions } = slice;
// export const { updateSelectProducts, updateSubmitList } = actions;
export default reducer;
